// src/store.js
// the single source of truth for your application state.
// Creates and exports the Redux store, combining the auth, drivers, agencies, agencyAccounts, and ui slices into one application state.
// =============================
// src/store.js
// =============================
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import driversReducer from './features/drivers/driverSlice';
import agenciesReducer from './features/agencies/agenciesSlice';
import accountsReducer from './features/agencyAccounts/agencyAccountsSlice';
import uiReducer       from './features/ui/filtersSlice';

export default configureStore({
  reducer: {
    auth:           authReducer,
    drivers:        driversReducer,
    agencies:       agenciesReducer,
    agencyAccounts: accountsReducer, 
    ui:             uiReducer,    
  },
});
